<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import PageHead from "@/components/PageHead/PageHead.vue";
import Width from "@/pages/Index/Width.vue";
import DateBlock from "@/pages/News/components/DateBlock.vue";
import axios from "axios";
import { useStore } from "vuex";
import {extractText} from "../../utils";
import Pagination from "@/components/Pagination/Pagination.vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
import { pageBg } from "@/constant";

const store = useStore()
const router = useRouter()

const activeTab = ref(1)
const news = ref([])
const total = ref(0)
const page = ref(1)
const windowWidth = ref(1920)

const currentLang = computed(() => {
	
	const lang = store.getters.currentLanguage
	
	return lang === 'cn' ? 'zh' : lang
	
})

const pagerCount = computed(() => {
	return windowWidth.value > 1024 ? 7 : 5
})

const getNews = () => {
	axios.get("/api/api/new?page=" + page.value).then((res) => {
		console.log(res.data);
		news.value = res.data[activeTab.value].data
		total.value = res.data[activeTab.value].total
	});
}

const handleTabChange = (e) => {
	page.value = 1
	
	getNews()
}

const handlePageChange = (e) => {
	page.value = e
	getNews()
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth'
	})
}

function handleResize() {
	windowWidth.value = window.innerWidth;
}
const getWindowInfo = () => {
	window.addEventListener('resize', () => handleResize());
}

const handleToDetail = (id) => {
	const routeInfo = router.resolve({
		path: `/details/${id}`
	})
	
	window.open(routeInfo.href, '_blank');
	
}

onMounted(() => {
	windowWidth.value = window.innerWidth;
	getWindowInfo()
	getNews()
})

onBeforeUnmount(() => {
	window.removeEventListener('resize', handleResize)
})

</script>

<template>
	<div class="news">
		<PageHead
			:title="$t('content.News')"
			:bg-image="pageBg.newsBg"
		/>
		<Width>
			<div class="news__content">
				<el-tabs
					v-model="activeTab"
					class="news__content__tab"
					@tab-change="handleTabChange"
				>
					<el-tab-pane
						:label="$t('content.Company')"
						:name="1"
					/>
					
					<el-tab-pane
						:label="$t('content.Industry')"
						:name="2"
					/>
				</el-tabs>
				
				<div class="news__content__list">
					<div
						class="news__content__list__item"
						v-for="(item, index) in news"
					>
						<div class="left">
							<DateBlock
								class="left__date"
								:date="item.time"
							/>
							
							<div class="center" @click="handleToDetail(item.id)">
								<div
									class="center__title line-clamp-2"
								>
									{{ item[`title${currentLang}`] || item?.titlezh }}
								</div>
								
								<div
									class="center__desc line-clamp-2"
								>
									{{ extractText(item[`content${currentLang}`] || item?.contentzh) }}
								</div>
								
								<div class="date__mobile">
									{{ dayjs(item.time).format('YYYY-MM-DD') }}
								</div>
							</div>
						</div>
						
						
						
						<div class="right" v-if="item.cover">
							<div class="right__img">
								<el-image
									:src="item.cover"
									style="width: 100%; height: 100%;"
									fit="cover"
								/>
							</div>
						</div>
					</div>
					
					<div class="pagin">
						<Pagination
							v-model:currentPage="page"
							background
							layout="prev, pager, next"
							:default-page-size="13"
							:total="total"
							:pagerCount="pagerCount"
							@change="handlePageChange"
						/>
					</div>
				</div>
			</div>
		</Width>
	</div>
</template>
<style scoped lang="less">

.news {
	background-color: #F5F5F5;
	&__content {
		margin-top: 30px;
		
		&__tab {
			margin-bottom: 70px;
		}
		
		&__list {
			
			&__item {
				display: flex;
				align-items: center;
				margin-bottom: 50px;
				
				&:hover {
					.center {
						&__title {
							font-weight: bold;
						}
						
						&__desc {
							color: #606266;
						}
						
					}
				}
				
				.left{
					padding: 46px 0;
					display: flex;
					border-bottom: 1px solid #E4E7ED;
					margin-right: 30px;
					flex: 1;
					
				}
				
				.center {
					cursor: pointer;
					margin-left: 30px;
					
					
					&__title {
						font-size: 24px;
						color: #303133;
					}
					
					&__desc {
						margin-top: 20px;
						font-size: 18px;
						color: #909399;
						line-height: 28px;
					}
					
					.date__mobile {
						display: none;
						font-size: 12px;
						margin-top: 10px;
						color: #A8ABB2;
					}
					
				}
				
				.right {
					
					&__img {
						width: 320px;
						height: 200px;
						border-radius: 12px;
						overflow: hidden;
						
						.el-image {
							transition: all .3s;
						}
						
						&:hover {
							
							.el-image {
								transform: scale(1.2);
							}
						}
					}
				
				}
				
			}
			
			.pagin{
				display: flex;
				justify-content: center;
				margin-bottom: 70px;
			}
			
		}
		
	}
	
	::v-deep(.el-tabs__item) {
		color: #3D3D3D;
		font-size: 20px;
		
		.is-active {
			font-weight: bold;
		}
		
	}
	
	::v-deep(.el-tabs__nav) {
		
		.is-active {
			color: @primary-color;
			font-weight: bold;
		}
		
		.el-tabs__active-bar {
			background-color: @primary-color;
		}
	}
	
	::v-deep(.el-image__error) {
		background-color: #ccc;
		color: #303133;
	}
	
}

@media only screen and (max-width: 768px) {
	.news {
		
		&__content {
			margin-top: 30px;
			
			&__tab {
				margin-bottom: 0;
			}
			
			&__list {
				
				&__item {
					margin-bottom: 20px;
					
					.left {
						padding: 16px 0;
						margin-right: 20px;
						
						&__date {
							display: none;
						}
					}
					
					.right {
						&__img {
							width: 100px;
							height: 100px;
							border-radius: 4px;
						}
					}
					
					.center {
						margin-left: 0;
						&__title {
							font-size: 16px;
							line-height: 20px;
						}
						
						&__desc {
							display: none;
							font-size: 14px;
							margin-top: 10px;
						}
						
						.date__mobile {
							display: block;
						}
						
					}
					
				}
				
				.pagin{
					margin-bottom: 30px;
				}
			}
			
		}
		
	}
}
</style>